module.exports = __webpack_public_path__ + "static/images/success.9f5d197e883544698575a02c29b6f802.svg";